import { Route } from "react-router-dom";
import SuperAdminClients from "./pages/SuperAdminClients";

import SuperAdminAccount from "./pages/SuperAdminAccount";
import SuperAdminSupport from "./pages/SuperAdminSupport";
import ClientAdminRemovals from "../clientAdmin/pages/ClientAdminRemovals";
import AccountActivate from "./pages/AccountActivate";
import ClientAdminSetting from "../clientAdmin/pages/ClientAdminSetting";
import ClientAdminDiary from "../clientAdmin/pages/ClientAdminDiary";
import ClientAdminSurveryDiary from "../clientAdmin/pages/ClientAdminSurveyDiary";
import CustomerQuotationScreen from "../customerAdmin/pages/CustomerQuotationScreen";
import ClientAdminWorkDiary from "../clientAdmin/pages/ClientAdminWorkDiary";
import ClientAccountSetting from "../clientAdmin/pages/ClientAccountSetting";
import ClientAdminDashboard from "../clientAdmin/pages/ClientAdminDashboard";
import ClientVehicleType from "../clientAdmin/pages/ClientVehicleType";
import ClientAdminVehicles from "../clientAdmin/pages/ClientAdminVehicles";
import ClientOperationStaff from "../clientAdmin/pages/ClientOperationStaff";
import ClientOperationAssignWorker from "../clientAdmin/pages/ClientOperationAssignWorker";
import ClinetSubContractors from "../clientAdmin/pages/ClientSubContractors";
import ClientOperationSignOffTask from "../clientAdmin/pages/ClientOperationSignOffTask";
import ClientAdminStorage from "../clientAdmin/pages/ClientAdminStorage";
import ClientAdminComplaints from "../clientAdmin/pages/ClientAdminComplaints";
import ClientJobCompletion from "../clientAdmin/pages/ClientJobCompletion";

export const superAdminRoutes = () => {
    return (
        <>
            <Route path="/dashboard-report" element={<ClientAdminDashboard />} />
            <Route path="/dashboard" element={<ClientAdminRemovals />} />
            <Route path="/storage" element={<ClientAdminStorage />} />
            <Route path="/diary" element={<ClientAdminDiary />} />
            <Route path="/survey-diary" element={<ClientAdminSurveryDiary />} />
            <Route path="/work-diary" element={<ClientAdminWorkDiary />} />
            <Route path="/clients" element={<SuperAdminClients />} />
            <Route path="/supports" element={<SuperAdminSupport />} />
            <Route path="/profile" element={<SuperAdminAccount />} />
            <Route path="/activate" element={<AccountActivate />} />
            <Route path="/settings" element={<ClientAdminSetting />} />
            <Route path="/account-settings" element={<ClientAccountSetting />} />
            <Route path="/quotation-confirmation" element={<CustomerQuotationScreen />} />
            <Route path="/vehicle-type" element={<ClientVehicleType />} />
            <Route path="/operation/vehicles" element={<ClientAdminVehicles />} />
            <Route path="/operation/staff" element={<ClientOperationStaff />} />
            <Route path="/operation/assign-worker" element={<ClientOperationAssignWorker />} />
            <Route path="/operation/subcontractors" element={<ClinetSubContractors />} />
            <Route path="/operation/task-signoff" element={<ClientOperationSignOffTask />} />
            <Route path="/complaints" element={<ClientAdminComplaints />} />
            <Route path ="/job-completion" element ={<ClientJobCompletion/>} />
        </>
    )
}